import React, { ReactNode } from 'react';
import { Popup, PopupProps } from 'antd-mobile';
import s from './index.module.scss';
import { CloseOutline } from 'antd-mobile-icons';

interface ModalPopupProps extends Omit<PopupProps, 'children'> {
  visible: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  height?: number;
}

const ModalPopup: React.FC<ModalPopupProps> = ({ visible, title, onClose, children, height = 200, ...rest }) => {
  return (
    <Popup
      visible={visible}
      onClose={onClose}
      closeOnMaskClick={true}
      bodyStyle={{
        borderRadius: '15px 15px 0 0'
      }}
      {...rest}
    >
      <div className={s['modal-popup']}>
        <div className={s['modal-popup-header']}>
          <span className={s['modal-popup-lf']}></span>
          <span className={s['modal-popup-title']}>{title}</span>
          <span className={s['modal-popup-close']} onClick={onClose}><CloseOutline /></span>
        </div>
        <div className={s['modal-popup-content']} style={{ minHeight: height ? `${height}px` : 'auto' }}>{children}</div>
      </div>
    </Popup>
  );
};

export default ModalPopup;